import year from '@/utils/year'
import { analytic, map } from '@/api/api-endpoints'
import url from '@/utils/url'
import { Formed, Regions, WasteGenerators } from '@/config/config'
import { PERIODS } from '@/config/regions/parts/report-types'
import chartOptionsData from '../utils/chartOptionsData'
import textMixin from '@/mixins/text-mixin'

// TODO: убрать после показа 2016
const FieldsModel = () => ({
  dynamicType: null,
  garbageType: Formed,
  garbageYear: year.getCurrentYear(),
  garbageVolumeYear: year.getCurrentYear(),
  garbageProductionYear: year.getCurrentYear(),
  garbageOutputYear: year.getCurrentYear(),
  formYear: year.getCurrentYear(),
  formStart: year.getCurrentYear(),
  formEnd: year.getCurrentYear() + 1,
  dynamicTypeTmpName: null,
  dynamicTypePeriod: 0,
  dynamic: { viewMode: WasteGenerators },
  garbageHandlingDynamic: { viewMode: Regions },
  garbageProduction: { viewMode: Regions },
  garbageCalculation: { viewMode: 'individual_area' },
  garbageKp: { viewMode: 'with_containers' },
  garbageVolume: { viewMode: WasteGenerators },
  msn: { viewMode: WasteGenerators },
  msnContainer: { viewMode: WasteGenerators },
  garbageOutput: { viewMode: Regions },
})

export default {
  mixins: [textMixin],
  data() {
    return {
      yearsOptions: [],
      chartLoading: false,
      chartError: null,
      fields: new FieldsModel(),
      chartVolumeGarbageSeries: [],
      chartMSNSeries: [],
      chartMSNContainerSeries: [],
      chartCountGarbageSeries: [],
      chartCountGarbageOptions: {},
      chartProductionGarbageSeries: [],
      chartProductionGarbageOptions: {},
      chartCalculationGarbageSeries: {},
      chartKpGarbageSeries: {},
      chartCalculationGarbageOptions: {},
      chartDynamicSeries: [],
      chartDynamicOptions: {},
      chartDynamicTypeOptions: [],
      chartGarbageHandlingDynamicSeries: [],
      chartGarbageHandlingDynamicOptions: {},
      chartGarbageOutputSeries: [],
      chartFormSeries: [],
      chartFormOptions: {},
      chartGeneratedTkoOptions: {},
      chartGeneratedTkoSeries: [],
    }
  },
  watch: {
    fields: {
      handler: function () {
        this.saveStateInRoute()
      },
      deep: true,
    },
  },
  created() {
    this.$store
      .dispatch('updateUrlEndpoint', {
        endpoint: this.getYearUrl(),
        fromCache: true,
      })
      .then(({ data: { year = [] } }) => {
        this.yearsOptions = []
        year.map((i) => this.yearsOptions.push({ id: i.year, name: i.year }))
      })
    this.setFieldsFromRoute()
  },
  title: function () {
    return this.$route?.params?.chartId ? this.documentTitle : false
  },
  computed: {
    getCurrentChartOptions() {
      return this.getChartOptions(this.$route.params.chartId) || {}
    },
    documentTitle() {
      return this.getCurrentChartOptions.documentTitle
    },
    dynamicTypePeriodOptions() {
      return PERIODS
    },
    chartRedirectParams() {
      let prevRoute = JSON.stringify(url.getRoute(this.$route))
      const setFields = JSON.stringify(this.fields)
      return { name: 'analytic.chart', query: { setFields, prevRoute } }
    },
    chartGarbageOutputOptions() {
      return chartOptionsData.garbageOutput.options
    },
    chartMSNContainerOptions() {
      return chartOptionsData.msnContainer.options
    },
    chartVolumeGarbageOptions() {
      return chartOptionsData.garbageVolume.options
    },
    chartMSNOptions() {
      return chartOptionsData.msn.options
    },
    chartYearOptions() {
      return this.yearsOptions
    },
    chartViewModeOptions() {
      return [
        { id: WasteGenerators, name: 'по объектам' },
        { id: Regions, name: 'по районам' },
      ]
    },
    chartViewGarbageType() {
      return [
        { id: 'individual_area', name: 'Индивидуальные жилые дома' },
        { id: 'med', name: 'Медицинские учреждения' },
        { id: 'mkd', name: 'Многоквартирные дома' },
        {
          id: 'animal_husbandry',
          name: this.garbageAnimalHusbandryText,
        },
        { id: 'recreation_purpose', name: 'Объекты рекреационного назначения' },
        {
          id: 'agricultural_purpose',
          name: 'Объекты сельскохозяйственного назначения',
        },
        { id: 'organization', name: 'Организация/ИП' },
        { id: 'country_community', name: 'Садовые, дачные партнерства' },
        { id: 'hostel', name: 'Управляющие организации' },
      ]
    },
    chartViewGarbageKp() {
      return [
        { id: 'with_containers', name: 'Контейнерные площадки' },
        { id: 'without_containers', name: 'Бесконтейнерный сбор' },
        { id: 'recyclables_collection', name: 'Пункты сбора вторсырья' },
        {
          id: 'mercurial_collection',
          name: 'Места хранения отработанных ртутьсодержащих объектов',
        },
      ]
    },
  },
  methods: {
    getYearUrl() {
      return map.yearFuture()
    },
    fetchChartData() {
      this.chartLoading = true
      const endpoint = this.buildEndpoint()
      this.chartError = null
      return this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint,
          params: { disableGlobalError: true },
        })
        .then((r) => {
          requestAnimationFrame(() => {})
          return r
        })
        .catch((e) => {
          this.chartError = e
          return e
        })
        .finally(() => (this.chartLoading = false))
    },
    getDiffed(asJson = true) {
      let defaultFields = new FieldsModel()
      let diffed = {}
      for (let key in this.fields) {
        // skip tmp and not changed from default values
        if (defaultFields[key] !== this.fields[key]) {
          diffed[key] = this.fields[key]
        }
      }
      return asJson ? JSON.stringify(diffed) : diffed
    },
    saveStateInRoute() {
      let route = url.getRoute(this.$route)
      route.query.setFields = this.getDiffed()
      if (route.query.prevRoute) {
        let prevRoute = JSON.parse(route.query.prevRoute)
        prevRoute.query.setFields = route.query.setFields
        route.query.prevRoute = JSON.stringify(prevRoute)
      }
      this.$router.replace(route)
    },
    setFieldsFromRoute() {
      let route = url.getRoute(this.$route)
      if (route.query.setFields) {
        let fields = JSON.parse(route.query.setFields)
        for (let key in fields) {
          this.fields[key] = fields[key]
        }
      }
    },
    getChartSeries(type) {
      return chartOptionsData[type].series
    },
    getChartOptions(type) {
      return chartOptionsData[type].options
    },
    transform({ data: { data = [] } }) {
      return [
        {
          data: data?.length
            ? data.map(({ name, y }) => ({ name, y: +y }))
            : [],
        },
      ]
    },
    getEndpoint() {
      return analytic.chart
    },
  },
  asyncData() {
    return Promise.resolve(1)
  },
}
